import Axios from 'axios'
import {
	IPricesAndCostsApply,
	IPricesAndCostsCalculate,
	IPricesAndCostsConfirm,
	IPricesAndCostsNewValue,
	IPricesAndCostsPaginate
} from 'models/PricesAndCostsMassiveUploadInterface'

export const pricesAndCostsApply = async (params: IPricesAndCostsApply) => {
	const response = await Axios.post(`inv_mod_precost/aplicar`, params)
	return response.data
}
export const pricesAndCostsCalculate = async (
	params: IPricesAndCostsCalculate
) => {
	const response = await Axios.post(`inv_mod_precost/calcular`, params)
	return response.data
}

export const pricesAndCostsConfirm = async (params: IPricesAndCostsConfirm) => {
	const response = await Axios.post(`inv_mod_precost/confirmar`, params)
	return response.data
}
export const pricesAndCostsPaginate = async (
	params: IPricesAndCostsPaginate
) => {
	const response = await Axios.post(`inv_mod_precost/paginar`, params)
	return response.data
}
export const pricesAndCostsVerify = async (idOperacion: any) => {
	const response = await Axios.get(
		`inv_mod_precost/verificar?idOperacion=${idOperacion}`
	)
	return response.data
}
export const pricesAndCostsNewValue = async (
	params: IPricesAndCostsNewValue
) => {
	const response = await Axios.post(`inv_mod_precost/valor`, params)
	return response.data
}
